import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useAsProp } from "@xo-union/react-polymorphic";
import styles from "./styles.css";

/**
 * Wrap content that should only be visible to screen readers.
 *
 * ref is forwarded to underlying element
 *
 *
 * ### When to use `ScreenReaderOnly` instead of `aria-label`
 *
 * Use this component when the screen-reader content is a superset of the visual content or in
 * cases where the existing HTML is complex (hierarchically) but is mostly correct when read out
 * loud by a screen-reader -- In this case `ScreenReaderOnly` should only enhance the information
 * that is already present in the DOM. In this scenario `ScreenReaderOnly` will also help you avoid
 * duplication of HTML text (that may be rendered in separate HTML nodes) on `aria-label`
 * properties.
 *
 */
const ScreenReaderOnly = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    as,
    className,
    ...props
  } = _ref;
  const ComponentToRender = useAsProp(as);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: cx(styles['sr-only'], className)
  }, props));
});
process.env.NODE_ENV !== "production" ? ScreenReaderOnly.propTypes = {
  /**
   * Underlying element type to render
   */
  as: PropTypes.elementType,
  /**
   * Additional class to append
   */
  className: PropTypes.string
} : void 0;
ScreenReaderOnly.defaultProps = {
  as: 'span'
};
export default ScreenReaderOnly;